<template>
<div class="section-container">
    <CollapsedContent :title="content.title" :index="4">
        <div class="container-box">
            <div id="hs-box-left" class="box left">
                {{ content.left }}
            </div>
            <div class="list">
                <div v-for="text in content.content" :key="text">{{text}}</div>
            </div>
            <div id="hs-box-right" class="box right">
                {{ content.right }}
            </div>
        </div>
    </CollapsedContent>
</div>
</template>

<script setup>
import { updateOnScroll,elementHeight,elementBottom } from "basic-scroll-animations";
import textMap from "@/scripts/locale.js";
import { onMounted, ref } from "vue";
import CollapsedContent from "@/components/CollapsedContent.vue";
import { useSectionStore } from "@/store/sectionStore";

const store = useSectionStore();

const content = ref(textMap.homeStaging);


onMounted(()=>{
    if(!store.isSafari){
        let lstart = elementBottom("#boxes");
        let height = 2*elementHeight("#boxes");
        if(window.innerWidth<window.innerHeight){
            lstart = lstart/2;
            height = height/2;
        }
        if(window.innerHeight < 500){
            lstart = 0;
            height = 0.01;
        }
        updateOnScroll("#hs-box-left")
            .from(lstart,{opacity:0, translateX: -100})
            .to(lstart+height,{opacity:1, translateX: 0});
        updateOnScroll("#hs-box-right")
            .from(lstart,{opacity:0, translateX: 100})
            .to(lstart+height,{opacity:1, translateX: 0});
    }
});

</script>

<style scoped>

</style>